import * as React from 'react';

export const FileContent = ({ file }) => {
  return (
    <div className='px-6 py-4'>
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-2'>
          <h1 className='text-2xl font-bold'>{file.title}</h1>
        </div>
      </div>
    </div>
  );
};
